import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";
import Seo from "@/components/common/Seo";
import Breadcrumbs from "@/components/common/Breadcrumbs";
import { Loader2 } from "lucide-react";

export default function PagePage() {
  const { slug } = useParams();
  const q = useQuery({
    queryKey: ["page", slug],
    queryFn: async () => {
      const { data } = await sharedApi.get(`/classifieds/pages/${slug}`);
      return data;
    },
    enabled: !!slug,
  });

  if (q.isLoading) {
    return (
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-20 text-center">
        <Loader2 className="w-6 h-6 mx-auto animate-spin text-slate-400" />
      </div>
    );
  }
  if (q.isError || !q.data) {
    return (
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-20 text-center">
        <h1 className="font-display text-3xl font-bold text-slate-900">Page not found</h1>
        <Link to="/" className="mt-6 inline-block rounded-full bg-[color:var(--brand-blue)] text-white font-bold px-5 py-2.5">Back home</Link>
      </div>
    );
  }
  const p = q.data;
  return (
    <article className="max-w-3xl mx-auto px-4 md:px-8 py-8 md:py-12">
      <Seo title={p.seo_title || p.title} description={p.seo_description} />
      <Breadcrumbs items={[{ label: p.title }]} />
      <h1 className="mt-6 font-display text-3xl md:text-5xl font-black text-slate-900 leading-tight tracking-tight">{p.title}</h1>
      <div className="prose prose-slate max-w-none mt-8 leading-relaxed" dangerouslySetInnerHTML={{ __html: p.body || "" }} />
    </article>
  );
}
